import React, { useContext } from 'react';

import Divider from '@material-ui/core/Divider';
import Editor from 'draft-js-plugins-editor';

import styled from 'styled-components/macro';

import { Map } from 'immutable';
import { Context } from '../engine/EmailDialogEngine';

const EditorWrapper = styled.div`
  margin: 1rem 0;
  max-height: 500px;
  overflow-y: auto;

  ${({ $customCSS }) => $customCSS}
`;

const Subject = styled.h2`
  margin: 1em 0;
  font-weight: 500;
  font-size: 18px;
`;

const customRenderMap = Map({
  unstyled: {
    element: 'div',
    // will be used in convertFromHTMLtoContentBlocks
    aliasedElements: ['p']
  }
});

const PreviewEmailView = props => {
  const context = useContext(Context);
  const { noSubject = true, topEndPoint = null } = context || {};

  return (
    <>
      {topEndPoint}
      {noSubject ? null : (
        <>
          <Subject>{props.subject || '(no subject)'}</Subject>

          <Divider />
        </>
      )}
      <EditorWrapper $customCSS={props.customCSS}>
        <Editor
          editorState={props.editorState}
          readOnly
          blockRenderMap={customRenderMap}
        />
      </EditorWrapper>
    </>
  );
};

export default PreviewEmailView;
